export default {"src":"/uk/_next/static/media/blueInfoIcon.e77ce1b9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};